import { io } from 'socket.io-client';
// Use same origin to be proxied by nginx to backend
const socket = io(window.location.origin, { transports: ['websocket'] });
export default socket;
